<div class="flex flex-col gap-6">
  <div class="flex items-center">
    <div class="flex flex-col flex-1">
      <h3 class="text-on-surface dark:text-on-surface-darkmode font-semibold">
        {{ 'cockpit.supplierContracts.details.general.sectionTitle' | transloco }}
      </h3>
      <p class="text-sm text-on-surface-variant dark:text-on-surface-variant-darkmode">
        {{ 'cockpit.supplierContracts.details.general.sectionDescription' | transloco }}
      </p>
    </div>
  </div>
  <div
    class="grid grid-cols-1 sm:grid-cols-2 items-center border-t border-surface-highlight dark:border-surface-highlight-darkmode"
  >
    <!-- contractScore -->
    @let contractScoreOverride = supplierContract().contractScoreOverride;
    @if (contractScoreOverride !== undefined) {
      <div
        class="pt-6 sm:py-6 sm:min-h-22 flex items-center gap-1 mb-[-1px] border-b-none sm:border-b border-surface-highlight dark:border-surface-highlight-darkmode text-on-surface dark:text-on-surface-darkmode text-sm font-semibold leading-6 line-clamp-2"
      >
        {{ 'cockpit.supplierContracts.details.general.contractScoreLabel' | transloco }}
        <ui-help-button class="flex-none font-normal text-sm">
          <h3 slot="title" class="font-semibold">
            {{ 'help.contractScore.title' | transloco }}
          </h3>
          <p>
            {{ 'help.contractScore.description' | transloco }}
          </p>
          <a
            slot="footer"
            [href]="'#'"
            target="_blank"
            [title]="'help.contractScore.linkTitle' | transloco"
          >
            <ui-button mode="outlined" type="button" size="small">
              <ng-icon name="heroArrowTopRightOnSquare" size="20" slot="start" class="!block" />
              {{ 'help.contractScore.linkText' | transloco }}
            </ui-button>
          </a>
        </ui-help-button>
      </div>
      <div
        class="pb-6 pt-1 sm:py-6 border-b border-surface-highlight dark:border-surface-highlight-darkmode"
      >
        <span
          class="min-h-10 flex items-center sm:px-3 sm:py-1.5 text-on-surface-subtle dark:text-on-surface-subtle-darkmode leading-6 line-clamp-1"
        >
          <ui-badge [color]="contractScoreOverride | scoreColor">
            {{ supplierContract().contractScoreOverride | score }}
          </ui-badge>
        </span>
      </div>
    }
    <!-- utilityType -->
    <div
      class="pt-6 sm:py-6 sm:min-h-22 flex items-center mb-[-1px] border-b-none sm:border-b border-surface-highlight dark:border-surface-highlight-darkmode text-on-surface dark:text-on-surface-darkmode text-sm font-semibold leading-6 line-clamp-2"
    >
      {{ 'cockpit.supplierContracts.details.general.utilityTypeLabel' | transloco }}
    </div>
    <div
      class="pb-6 pt-1 sm:py-6 border-b border-surface-highlight dark:border-surface-highlight-darkmode"
    >
      <span
        class="min-h-10 flex items-center sm:px-3 sm:py-1.5 text-on-surface-subtle dark:text-on-surface-subtle-darkmode leading-6 line-clamp-1"
      >
        <span class="inline-flex gap-0.5 items-center">
          @if (supplierContract().utilityType === 'ELECTRICITY') {
            <ng-icon name="heroBolt" size="20" class="!block" />
            {{ 'cockpit.supplierContracts.details.general.utilityTypeElectricity' | transloco }}
          } @else if (supplierContract().utilityType === 'GAS') {
            <ng-icon name="heroFire" size="20" class="!block" />
            {{ 'cockpit.supplierContracts.details.general.utilityTypeGas' | transloco }}
          }
        </span>
      </span>
    </div>
    <!-- supplierName -->
    <div
      class="pt-6 sm:py-6 sm:min-h-22 flex items-center mb-[-1px] border-b-none sm:border-b border-surface-highlight dark:border-surface-highlight-darkmode text-on-surface dark:text-on-surface-darkmode text-sm font-semibold leading-6 line-clamp-2"
    >
      {{ 'cockpit.supplierContracts.details.general.supplierLabel' | transloco }}
    </div>
    <div
      class="pb-6 pt-1 sm:py-6 border-b border-surface-highlight dark:border-surface-highlight-darkmode"
    >
      <span
        class="min-h-10 flex items-center sm:px-3 sm:py-1.5 text-on-surface-subtle dark:text-on-surface-subtle-darkmode leading-6 line-clamp-1"
      >
        {{ supplierContract().supplierName }}
      </span>
    </div>
    <!-- productName -->
    <div
      class="pt-6 sm:py-6 sm:min-h-22 flex items-center mb-[-1px] border-b-none sm:border-b border-surface-highlight dark:border-surface-highlight-darkmode text-on-surface dark:text-on-surface-darkmode text-sm font-semibold leading-6 line-clamp-2"
    >
      {{ 'cockpit.supplierContracts.details.general.productLabel' | transloco }}
    </div>
    <div
      class="pb-6 pt-1 sm:py-6 border-b border-surface-highlight dark:border-surface-highlight-darkmode"
    >
      <span
        class="min-h-10 flex items-center sm:px-3 sm:py-1.5 text-on-surface-subtle dark:text-on-surface-subtle-darkmode leading-6 line-clamp-1"
      >
        {{ supplierContract().productName }}
      </span>
    </div>
    <!-- supplierCustomerID -->
    <div
      class="pt-6 sm:py-6 sm:min-h-22 flex items-center mb-[-1px] border-b-none sm:border-b border-surface-highlight dark:border-surface-highlight-darkmode text-on-surface dark:text-on-surface-darkmode text-sm font-semibold leading-6 line-clamp-2"
    >
      {{ 'cockpit.supplierContracts.details.general.customerNumberLabel' | transloco }}
    </div>
    <div
      class="pb-6 pt-1 sm:py-6 border-b border-surface-highlight dark:border-surface-highlight-darkmode"
    >
      <span
        class="min-h-10 flex items-center sm:px-3 sm:py-1.5 text-on-surface-subtle dark:text-on-surface-subtle-darkmode leading-6 line-clamp-1"
      >
        {{ supplierContract().supplierCustomerID }}
      </span>
    </div>
    <!-- supplierCustomerID -->
    <div
      class="pt-6 sm:py-6 sm:min-h-22 flex items-center mb-[-1px] border-b-none sm:border-b border-surface-highlight dark:border-surface-highlight-darkmode text-on-surface dark:text-on-surface-darkmode text-sm font-semibold leading-6 line-clamp-2"
    >
      {{ 'cockpit.supplierContracts.details.general.contractNumberLabel' | transloco }}
    </div>
    <div
      class="pb-6 pt-1 sm:py-6 border-b border-surface-highlight dark:border-surface-highlight-darkmode"
    >
      <span
        class="min-h-10 flex items-center sm:px-3 sm:py-1.5 text-on-surface-subtle dark:text-on-surface-subtle-darkmode leading-6 line-clamp-1"
      >
        {{ supplierContract().supplierContractID }}
      </span>
    </div>
    <!-- contractStartDate -->
    <div
      class="pt-6 sm:py-6 sm:min-h-22 flex items-center mb-[-1px] border-b-none sm:border-b border-surface-highlight dark:border-surface-highlight-darkmode text-on-surface dark:text-on-surface-darkmode text-sm font-semibold leading-6 line-clamp-2"
    >
      {{ 'cockpit.supplierContracts.details.general.contractStartLabel' | transloco }}
    </div>
    <div
      class="pb-6 pt-1 sm:py-6 border-b border-surface-highlight dark:border-surface-highlight-darkmode"
    >
      <span
        class="min-h-10 flex items-center sm:px-3 sm:py-1.5 text-on-surface-subtle dark:text-on-surface-subtle-darkmode leading-6 line-clamp-1"
      >
        <ui-badge>
          {{ supplierContract().contractStartDate | date: 'dd.MM.yyyy' }}
        </ui-badge>
      </span>
    </div>
    @if (supplierContract().contractEndDate) {
      <!-- contractEndDate -->
      <div
        class="pt-6 sm:py-6 sm:min-h-22 flex items-center mb-[-1px] border-b-none sm:border-b border-surface-highlight dark:border-surface-highlight-darkmode text-on-surface dark:text-on-surface-darkmode text-sm font-semibold leading-6 line-clamp-2"
      >
        {{ 'cockpit.supplierContracts.details.general.contractEndLabel' | transloco }}
      </div>
      <div
        class="pb-6 pt-1 sm:py-6 border-b border-surface-highlight dark:border-surface-highlight-darkmode"
      >
        <span
          class="min-h-10 flex items-center sm:px-3 sm:py-1.5 text-on-surface-subtle dark:text-on-surface-subtle-darkmode leading-6 line-clamp-1"
        >
          <ui-badge>
            {{ supplierContract().contractEndDate | date: 'dd.MM.yyyy' }}
          </ui-badge>
        </span>
      </div>
    } @else {
      <!-- contractEndDate -->
      <div
        class="pt-6 sm:py-6 sm:min-h-22 flex items-center mb-[-1px] border-b-none sm:border-b border-surface-highlight dark:border-surface-highlight-darkmode text-on-surface dark:text-on-surface-darkmode text-sm font-semibold leading-6 line-clamp-2"
      >
        {{ 'cockpit.supplierContracts.details.general.terminationPeriodLabel' | transloco }}
      </div>
      <div
        class="pb-6 pt-1 sm:py-6 border-b border-surface-highlight dark:border-surface-highlight-darkmode"
      >
        <span
          class="min-h-10 flex items-center sm:px-3 sm:py-1.5 text-on-surface-subtle dark:text-on-surface-subtle-darkmode leading-6 line-clamp-1"
        >
          <ui-badge>
            {{ latestPossibleTerminationDate() | date: 'dd.MM.yyyy' }}
          </ui-badge>
        </span>
      </div>
    }
    <!-- locations -->
    <div
      class="pt-6 sm:py-6 sm:min-h-22 flex items-center mb-[-1px] border-b-none sm:border-b border-surface-highlight dark:border-surface-highlight-darkmode text-on-surface dark:text-on-surface-darkmode text-sm font-semibold leading-6 line-clamp-2"
    >
      {{ 'cockpit.supplierContracts.details.general.locationsLabel' | transloco }}
    </div>
    <div
      class="pb-6 pt-1 sm:py-6 border-b border-surface-highlight dark:border-surface-highlight-darkmode"
    >
      <span
        class="min-h-10 flex items-center gap-1 sm:px-3 sm:py-1.5 text-on-surface-subtle dark:text-on-surface-subtle-darkmode leading-6 line-clamp-1"
      >
        @for (location of locations(); track $index) {
          <a
            href="/organizations/{{ organizationId() }}/locations/{{ location.id }}"
            target="_blank"
            [title]="'cockpit.supplierContracts.details.general.clickToOpenTitle' | transloco"
          >
            <ui-badge mode="clickable">
              <span class="inline-flex items-center gap-1">
                <ng-icon name="heroArrowTopRightOnSquare" size="12" class="!block" />
                {{ location | formatLocationName }}
              </span>
            </ui-badge>
          </a>
        }
      </span>
    </div>
    <!-- energy-interfaces -->
    <div
      class="pt-6 sm:py-6 sm:min-h-22 flex items-center mb-[-1px] border-b-none sm:border-b border-surface-highlight dark:border-surface-highlight-darkmode text-on-surface dark:text-on-surface-darkmode text-sm font-semibold leading-6 line-clamp-2"
    >
      {{ 'cockpit.supplierContracts.details.general.connectionsLabel' | transloco }}
    </div>
    <div
      class="pb-6 pt-1 sm:py-6 border-b border-surface-highlight dark:border-surface-highlight-darkmode"
    >
      <span
        class="min-h-10 flex items-center gap-1 sm:px-3 sm:py-1.5 text-on-surface-subtle dark:text-on-surface-subtle-darkmode leading-6 line-clamp-1"
      >
        @for (ei of energyInterfaces(); track $index) {
          <a
            href="/organizations/{{ organizationId() }}/energy-interfaces/{{ ei.id }}"
            target="_blank"
            [title]="'cockpit.supplierContracts.details.general.clickToOpenTitle' | transloco"
          >
            <ui-badge mode="clickable">
              <span class="inline-flex items-center gap-1">
                <ng-icon name="heroArrowTopRightOnSquare" size="12" class="!block" />
                {{ ei.maloID || ei.label }}
              </span>
            </ui-badge>
          </a>
        }
      </span>
    </div>
    <!-- yearly-consumption -->
    <div
      class="pt-6 sm:py-6 sm:min-h-22 flex items-center mb-[-1px] border-b-none sm:border-b border-surface-highlight dark:border-surface-highlight-darkmode text-on-surface dark:text-on-surface-darkmode text-sm font-semibold leading-6 line-clamp-2"
    >
      {{ 'cockpit.supplierContracts.details.general.annualConsumptionLabel' | transloco }}
    </div>
    <div
      class="pb-6 pt-1 sm:py-6 border-b border-surface-highlight dark:border-surface-highlight-darkmode"
    >
      <span
        class="min-h-10 flex items-center sm:px-3 sm:py-1.5 text-on-surface-subtle dark:text-on-surface-subtle-darkmode leading-6 line-clamp-1"
      >
        @if (!price() || price()?.isLoading) {
          <ui-skeleton class="block h-6 w-30 rounded-md" />
        } @else if (price()?.error) {
          <ui-input-error>{{
            'cockpit.supplierContracts.details.general.totalConsumptionError' | transloco
          }}</ui-input-error>
        } @else {
          <ui-badge>
            {{ totalConsumption() | germanNumber: 2 }}
            {{ 'cockpit.supplierContracts.units.referenceUnit.KWH' | transloco }}
          </ui-badge>
        }
      </span>
    </div>
  </div>
</div>
